import css from './CardFlipItem.module.scss'
import React, { PropsWithChildren } from 'react'
import classNames from 'classnames'

import DataTestId from 'meta/dataTestId'
import { IUserTicketData } from 'meta/pages/v4/ticket'

import Img from 'components/Media/Img'
import { useUrlCloudfront } from 'hooks/useEnv'

type Props = {
  className: string
  ticketData: IUserTicketData
  changeShowDetail: () => void
  showDetails: boolean
  useLongCard?: boolean
}

const CardFlipItem: React.FC<PropsWithChildren<Props>> = (props) => {
  const { children, className, ticketData, changeShowDetail, showDetails, useLongCard } = props
  const urlCloudfront = useUrlCloudfront()

  return (
    <div className={className}>
      <div
        className={classNames(css.walletTicketCard, { [css.long]: useLongCard })}
        style={{ backgroundImage: `url(${urlCloudfront}/images/wallet/ticket_grey${useLongCard ? '_long' : ''}.svg)` }}
      >
        {ticketData.secret && (
          <button
            className={css.walletTicketCard__btnInfo}
            data-testid={showDetails ? DataTestId.wallet.btnInfoDetails : DataTestId.wallet.btnInfoBase}
            onClick={(event) => {
              event.preventDefault()
              event.stopPropagation()
              changeShowDetail()
            }}
          >
            <Img src={showDetails ? `/icons/arrow_left_white.svg` : `/icons/info_white.svg`} />
          </button>
        )}
        {React.Children.toArray(children)}
      </div>
    </div>
  )
}

export default CardFlipItem
